import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import * as React from "react";
import styled from "styled-components";

export const MakerSignUpFooterWrapper: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <>
      <Spacer size="10x" />
      <MobileStickyFooter>{children}</MobileStickyFooter>
    </>
  );
};

const MobileStickyFooter = styled(Column)`
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: ${Core.surface.inverse};
`;
